import { mockDataAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-ext-count';
const CONV_ID = 'conv-2';
const MD_BLOCK_ID = 'blk-ext-md';
const TABLE_BLOCK_ID = 'blk-ext-tbl';
const markdownText = 'I found **47 fire extinguishers** across 3 buildings. Here is the breakdown by building:';
const dataTableBlock = {
    type: 'data_table',
    block_id: TABLE_BLOCK_ID,
    block_index: 1,
    title: 'Fire Extinguishers by Building',
    columns: [
        { key: 'building', label: 'Building', sortable: true },
        { key: 'count', label: 'Count', sortable: true, align: 'right', format: 'number' },
        { key: 'last_inspected', label: 'Last Inspected', sortable: true, format: 'date' }
    ],
    rows: [
        { building: 'Building A - Main Office', count: 18, last_inspected: '2025-01-15' },
        { building: 'Building B - Warehouse', count: 22, last_inspected: '2025-02-01' },
        { building: 'Building C - Annex', count: 7, last_inspected: '2024-12-20' }
    ],
    total_rows: 3,
    displayed_rows: 3,
    export_options: ['csv', 'excel']
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockDataAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(dataTableBlock, 100),
    makeStreamEnd(RESPONSE_ID, 2, mockDataAgent)
];
export const scenario = {
    name: 'Data Assistant — Extinguisher Count',
    description: 'Count query with streaming markdown followed by an atomic data table block.',
    conversations: mockConversations,
    userMessage: 'How many fire extinguishers do we have?',
    agentIdentity: mockDataAgent,
    sseSequence
};
